import { GridColDef } from '@mui/x-data-grid';
import numberDecorator from 'src/decorators/number.decorator';
import { EstimationEntity } from 'src/entities/Estimation.entity';
import numberUtil from 'src/utils/number.util';

const costHourColumns: GridColDef[] = [
  {
    field: 'deliveryName',
    headerName: '勤務計画',
    type: 'string' as const,
  },
  {
    field: 'orderOperationSeconds',
    headerName: '車庫帰着を除く時間',
    type: 'number' as const,
    valueGetter: (params: { row: EstimationEntity }) => numberUtil.convertFromSecondsToMinutes(params.row.orderOperationSeconds),
    valueFormatter: (value: number) => numberDecorator.toRoundedUnit(
      value,
      '分',
      1,
      ''
    )
  },
  {
    field: 'totalSeconds',
    headerName: '合計時間',
    type: 'number' as const,
    valueGetter: (params: { row: EstimationEntity }) => numberUtil.convertFromSecondsToMinutes(params.row.orderOperationSeconds + params.row.arrivalOperationSeconds),
    valueFormatter: (value: number) => numberDecorator.toRoundedUnit(
      value,
      '分',
      1,
      ''
    )
  },
  {
    field: 'expectedFeeYenByHour',
    headerName: '🖊️1時間あたり運賃',
    type: 'number' as const,
    editable: true,
    valueFormatter: (value: number) => numberDecorator.toYen(
      value
    )
  },
  {
    field: 'feeExcludeArrivalOperation',
    headerName: '運賃（車庫帰着を除く）',
    type: 'number' as const,
    valueGetter: (params: { row: EstimationEntity }) => {
      if (!params.row.expectedFeeYenByHour) return undefined;

      const seconds = params.row.orderOperationSeconds;

      return seconds * (params.row.expectedFeeYenByHour / 3600);
    },
    valueFormatter: (value: number) => numberDecorator.toYen(
      value,
    ),
  },
  {
    field: 'fee',
    headerName: '運賃',
    type: 'number' as const,
    valueGetter: (params: { row: EstimationEntity }) => {
      if (!params.row.expectedFeeYenByKm) return undefined;

      const seconds = params.row.orderOperationSeconds + params.row.arrivalOperationSeconds;

      return seconds * (params.row.expectedFeeYenByHour / 3600);
    },
    valueFormatter: (value: number) => numberDecorator.toYen(
      value,
    ),
  },
];

export default costHourColumns;
